class RecentlyPurchased extends HTMLElement {
  constructor() {
    super();
    this.ELM_content = this.querySelector('[data-content]');
    const self = this;

    fetch('https://survival-mw.herokuapp.com/recently-purchased')
      .then(res => res.json())
      .then(data => {
        if (data && data.length) {
          self.render.bind(self)(data);
        }
      })
  }

  render(data) {
    let orders_html = '';
    const defaultMessage = theme?.strings?.default_message_of_support || '';
    data.forEach(order => {
      orders_html += `<div class="recent-order">
        <div class="recent-order__product">
          <div data-product-id="${ order.product.product_id }" class="recent-order__product-image">
            <img src="${ order.product.image.src }" />
          </div>
          <h6 class="recent-order__product-title">${ order.product.title }</h6>
        </div>
        <div class="recent-order__customer">
          ${ order.attributes?.customer_message || defaultMessage ? `<div class="recent-order__customer-message">
            ${ SVG_quote }
            ${ order.attributes?.customer_message || defaultMessage }
            ${ SVG_quote }
          </div>` : defaultMessage }
          <div class="recent-order__customer-info">
            <div>Purchased by: <strong>${ order.attributes?.stay_anonymous ? 'Anonymous' : order.customer.first_name }</strong></div>
            <div>Location: <strong>${ order.customer.city }</strong></div>
          </div>
        </div>
      </div>`;
    });

    const html = `<div data-recently-purchased-carousel>
      ${ orders_html }
    </div>`;

    this.ELM_content.innerHTML = html;
    document.dispatchEvent(new CustomEvent('recentlyPurchased::loaded'));
  }
}

customElements.define('recently-purchased', RecentlyPurchased);
